module.exports = __webpack_public_path__ + "static/media/ic-route-arrow-light.b74e8677.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/ic-route-arrow-light.svg
// module id = 268
// module chunks = 0